import MainTitle from '../../utils/MainTitle'
import Content from '../../utils/Content'
import LinkButton from '../../utils/LinkButton'
import AddForm from './Form'
const Categories = props => {
  return (<>
    <MainTitle>
      <h1>Añadir Categoría</h1>
      <LinkButton to="/categories">Regresar</LinkButton>
    </MainTitle>
    <Content>
      <AddForm />
    </Content>
  </>)
}

export default Categories